module.exports = __webpack_public_path__ + "img/photo-4.d143d08a.jpg";